import TabPage from "./../../factories/tab-page";
import GenericListTab from "./../../factories/generic-list-tab";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
import * as ko from "knockout";
import ShiftbookTransferDefinitionDialog from "./../dialogs/shiftbook-transfer-definition-dialog";
class ShiftbookTransferDefinition extends GenericListTab {
    Bao = Bao;
    DialogWidth = 1000;
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.Models.subscribe(() => {
            this.Selection([]);
        });
    }
    CustomFilter() {
        return null;
    }
    ItemCompleteCheck(item): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        var result = true;
        def.resolve(result);
        return def.promise();
    }
    Dialog(id: string): JQueryPromise<any> {
        this.TabPage.IsLoading(true);
        return Bao.post(this.UrlDialog(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: ko.unwrap(this.Parent.PrimaryKeyValue),
            id: id
        }), (result) => {
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            dialog.Template(result.Template);
            var vm = ko.map.fromJS(result.Model);
            vm.Parent = this;
            dialog.ViewModel(new ShiftbookTransferDefinitionDialog(vm));
            var okButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                var item = dialog.ViewModel();
                delete item.Parent;
                this.ItemCompleteCheck.call(this, item).then((validateResult) => {
                    if (validateResult) {
                        this.Save(ko.map.toJS(item)).then(() => {
                            this.TabPage.DirtyFlag(true);
                            dialog.Close();
                        });
                    }
                });
            });
            var cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                dialog.Close();
            });
            if (this.DialogWidth != null) {
                dialog.Width(this.DialogWidth + "px");
            }
            dialog.Buttons([okButton, cancelButton]);
            dialog.Open(null);
            this.TabPage.IsLoading(false);
        });
    }
}
export default ShiftbookTransferDefinition;